import API_URLS from "@constants/api.urls";

import { getRequest, postRequest } from "../baseApi";
import { sendEngagement } from "../engagementApi";

export const getUfCalcReport = reqBody => postRequest(API_URLS.ufCalcReport, reqBody);

export const getIxCalcReport = reqBody => postRequest(API_URLS.ixCalcReport, reqBody);

export const getRoCalcReport = reqBody => postRequest(API_URLS.roReport, reqBody);

export const getMultiTechReport = reqBody => postRequest(API_URLS.multiTechReport, reqBody);

export const createMLDReport = reqBody => postRequest(API_URLS.mldReportRequest, reqBody);
export const getMLDJobStatus = jobId => getRequest(`${API_URLS.mldReportStatus}/${jobId}`);
export const getMLDJobs = (params = {}) => getRequest(API_URLS.mldReportJobs, params); //not implemented yet
export const cancelMLDReport = reqBody => postRequest(API_URLS.mldReportCancel, { jobId: reqBody });

/**
 * Sends a PDF download engagement event to the DuPont engagement endpoint.
 *
 * @param {Object} payload - Payload containing engagementName and emailAddress.
 */
export const reportDownloadEngagement = payload => {
  sendEngagement({
    ...payload,
    engagementType: "Download",
    engagementSubType: "Document",
  });
};
